import { Controller } from "@hotwired/stimulus";

// Keeps the kiosk scan field ready for the next badge read after each page load.
// The result panel still shows the last lookup, but the input itself behaves like
// a fresh scan buffer instead of preserving stale RFID text that could be appended to.
export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.handlePageShow = this.handlePageShow.bind(this);
    window.addEventListener("pageshow", this.handlePageShow);
    this.prepareForNextScan();
  }

  disconnect() {
    window.removeEventListener("pageshow", this.handlePageShow);
  }

  handlePageShow() {
    this.prepareForNextScan();
  }

  prepareForNextScan() {
    if (!this.hasInputTarget) return;

    this.inputTarget.value = "";
    this.inputTarget.focus({ preventScroll: true });
  }
}
